import type React from "react";

import type { BoxProps, TextProps } from "metabase/ui";
import { Box, Text } from "metabase/ui";

export const SettingHeader = ({
  id,
  description,
  title,
  titleAsLabel = true,
  titleHeadingLevel,
  titleProps,
  ...boxProps
}: {
  id?: string;
  description?: string | React.ReactNode;
  title?: string;
  titleAsLabel?: boolean;
  titleHeadingLevel?: 2 | 3;
  titleProps?: TextProps;
} & BoxProps) => (
  <Box {...boxProps}>
    {title && (
      <SettingTitle
        {...titleProps}
        id={id}
        isLabel={titleAsLabel}
        headingLevel={titleHeadingLevel}
      >
        {title}
      </SettingTitle>
    )}
    {!!description && (
      <Text mb="sm" maw="38rem" lh="xl" c="text-secondary">
        {description}
      </Text>
    )}
  </Box>
);

function getSettingTitleComponent(
  isLabel: boolean,
  headingLevel: 2 | 3 | undefined,
) {
  if (isLabel) {
    return "label";
  }

  switch (headingLevel) {
    case 2:
      return "h2";
    case 3:
      return "h3";
    default:
      return "div";
  }
}

export const SettingTitle = ({
  id,
  isLabel = true,
  headingLevel,
  children,
  ...props
}: TextProps & {
  id?: string;
  isLabel?: boolean;
  headingLevel?: 2 | 3;
  children?: React.ReactNode;
}) => {
  const component = getSettingTitleComponent(isLabel, headingLevel);

  return (
    <Text
      id={isLabel ? undefined : id}
      htmlFor={isLabel ? id : undefined}
      component={component}
      c="text-primary"
      fw="bold"
      display="inline-block"
      {...props}
    >
      {children}
    </Text>
  );
};
